<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.92615 9.02344C9.68707 9.02344 9.49287 8.82968 9.49219 8.59009C9.4914 8.35016 9.68515 8.15494 9.92491 8.15426C11.0153 8.15087 12.0527 7.49174 12.8459 6.29821C13.6072 5.15266 14.0545 3.65457 14.1227 2.04105H12.2107C11.971 2.04105 11.7766 1.84651 11.7766 1.60646C11.7766 1.36642 11.971 1.17188 12.2107 1.17188H14.5659C14.8057 1.17188 15 1.36642 15 1.60646C15 3.55374 14.4917 5.39089 13.5688 6.77976C12.61 8.22228 11.3169 9.01914 9.92762 9.02344C9.92717 9.02344 9.92672 9.02344 9.92615 9.02344Z"
      fill="#FF8E1D"
    />
    <path
      d="M5.07385 9.02344C5.07328 9.02344 5.07294 9.02344 5.07249 9.02344C3.68322 9.01914 2.39003 8.22228 1.43133 6.77976C0.508345 5.39089 0 3.55374 0 1.60646C0 1.36642 0.194317 1.17188 0.434077 1.17188H2.78929C3.02905 1.17188 3.22336 1.36642 3.22336 1.60646C3.22336 1.84651 3.02905 2.04105 2.78929 2.04105H0.877311C0.945475 3.65457 1.39278 5.15266 2.15411 6.29821C2.94732 7.49174 3.9847 8.15087 5.07509 8.15426C5.31485 8.15494 5.5086 8.35016 5.50781 8.59009C5.50713 8.82968 5.31293 9.02332 5.07385 9.02344Z"
      fill="#FFB023"
    />
    <path
      d="M12.216 0H2.78403C2.54096 0 2.34375 0.196877 2.34375 0.439795C2.34375 3.02325 2.85088 5.45907 3.77158 7.29842C4.36149 8.47682 5.08291 9.33225 5.8807 9.82198V12.2165C5.8807 12.4594 6.07791 12.6562 6.32098 12.6562H8.67902C8.92221 12.6562 9.1193 12.4594 9.1193 12.2165V9.82198C9.91709 9.33236 10.6386 8.47682 11.2284 7.29842C12.1491 5.45907 12.6562 3.02325 12.6562 0.439795C12.6562 0.196877 12.4592 0 12.216 0Z"
      fill="#FBBE4B"
    />
    <path
      d="M9.1193 12.2165V9.82198C9.91709 9.33236 10.6386 8.47682 11.2284 7.29842C12.1491 5.45907 12.6562 3.02325 12.6562 0.439795C12.6562 0.196877 12.4592 0 12.216 0H7.5V12.6562H8.67902C8.92221 12.6562 9.1193 12.4594 9.1193 12.2165Z"
      fill="#FFB023"
    />
    <path
      d="M9.86216 11.8359H5.13784C4.2434 11.8359 3.51562 12.5457 3.51562 13.418V14.5699C3.51562 14.8074 3.71307 15 3.9567 15H11.0433C11.2869 15 11.4844 14.8074 11.4844 14.5699V13.418C11.4844 12.5457 10.7567 11.8359 9.86216 11.8359Z"
      fill="#FF8E1D"
    />
    <path
      d="M9.86216 11.8359H7.5V15H11.0433C11.2869 15 11.4844 14.8074 11.4844 14.5699V13.418C11.4844 12.5457 10.7567 11.8359 9.86216 11.8359Z"
      fill="#FF6D15"
    />
    <path
      d="M11.5124 15H3.48759C3.24428 15 3.04688 14.8164 3.04688 14.5899C3.04688 14.3633 3.24428 14.1797 3.48759 14.1797H11.5124C11.7558 14.1797 11.9531 14.3633 11.9531 14.5899C11.9531 14.8164 11.7558 15 11.5124 15Z"
      fill="#FFB023"
    />
    <path
      d="M11.5124 14.1797H7.5V15H11.5124C11.7558 15 11.9531 14.8164 11.9531 14.5899C11.9531 14.3633 11.7558 14.1797 11.5124 14.1797Z"
      fill="#FF8E1D"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
